import type { ReactNode } from 'react';
import { useNewsCtaClick, type NewsCtaSource } from '../../hooks/useNewsCtaClick';
import type { NewsPlatform } from '../../types/news.types';
import { getNewsCta } from '../../utils/news.utils';

/** Bouton d'action d'une nouveauté ; rien si elle n'en a pas. */
export function NewsCtaLink({
  platform,
  news,
  className,
  onInternalNavigation,
  children,
}: {
  platform: NewsPlatform;
  news: NewsCtaSource;
  className?: string;
  onInternalNavigation?: () => void;
  /** Contenu ajouté après le libellé (icône). */
  children?: ReactNode;
}) {
  const handleClick = useNewsCtaClick(platform, onInternalNavigation);
  const cta = getNewsCta(news);
  if (!cta) return null;

  return (
    <a
      href={cta.url}
      {...(cta.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      onClick={(event) => handleClick(news, event)}
      className={className}
    >
      {cta.label}
      {children}
    </a>
  );
}
